import { type JSX } from 'react';

import { Picture, QuickBetsIcon } from '@cx-modules/ui';

import { useOddsGridContext } from '../../context/OddsGridContext';
import { useBookmakerData } from '../../hooks/useBookmakerData';
import { useSelector } from '../../providers/StoreProvider';
import { oddsShownType } from '../../types';
import { BookmakerClickOut } from '../BookmakerClickOut';
import { StyledQuickBetIcon } from '../shared-styles';

import { BookmakerCellContainer, bookmakerImg, ImgWrapper } from './style';

export const BookmakerCell = ({
  bookieCode,
  isOffer = false,
  show = true,
}: {
  bookieCode: string;
  isOffer?: boolean;
  show?: boolean;
}): JSX.Element | null => {
  const repub = useSelector(state => state.repub);
  const { oddsShown } = useOddsGridContext();
  const { bookmaker, bookmakerData } = useBookmakerData(bookieCode);

  const isNonClickable = oddsShown === oddsShownType.OC_NON_CLICKABLE;
  const quickBet = false;

  const { code, name } = bookmaker;
  const { brandColour, logoLarge } = bookmakerData;

  if (!show) return null;
  return (
    <BookmakerClickOut
      bookmakerCode={code}
      eventLabel="grid_bookie_logo_top"
      isNonClickable={isNonClickable}
      repub={repub}
      show={show}
      title={name}
    >
      <BookmakerCellContainer backgroundColour={brandColour}>
        <ImgWrapper className={isOffer ? 'offer' : ''}>
          <Picture
            altText={name}
            className={bookmakerImg}
            style={{ height: '100%', width: '100%' }}
            svgSrc={logoLarge}
          />
        </ImgWrapper>
        {quickBet && (
          <StyledQuickBetIcon>
            <QuickBetsIcon />
          </StyledQuickBetIcon>
        )}
      </BookmakerCellContainer>
    </BookmakerClickOut>
  );
};
